export enum ChatTab {
    Home = 0,
    CustomerService = 1
}

export default ChatTab;
